﻿﻿﻿<mat-dialog-content>
    <!--<mat-checkbox (change)="onChange($event)">BusinessKeys?</mat-checkbox>-->
    <mat-checkbox class="checkbox-text" [(ngModel)]="deployment.BusinessKeys">BusinessKeys?</mat-checkbox>
    <mat-checkbox class="checkbox-text" [(ngModel)]="deployment.DebriefingItems">DebriefingItems?</mat-checkbox>

    <!--(change)="onDebriefingItemChange($event)"-->
</mat-dialog-content>
